import { render } from "./newsAdd.vue?vue&type=template&id=66e1a3fc&scoped=true"
import script from "./newsAdd.vue?vue&type=script&lang=js"
export * from "./newsAdd.vue?vue&type=script&lang=js"

import "./newsAdd.vue?vue&type=style&index=0&id=66e1a3fc&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e1a3fc"]])

export default __exports__